(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tout-voir-image-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tout-voir-menu')) {
    customElements.define('tout-voir-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.closeTimer = null;
        this.pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.addEventListener('mouseenter', () => {
          if (!this.pointerFine.matches) return;
          window.clearTimeout(this.closeTimer);
          this.details.open = true;
        });

        this.addEventListener('mouseleave', () => {
          if (!this.pointerFine.matches) return;
          this.closeTimer = window.setTimeout(() => {
            this.details.open = false;
          }, 140);
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          this.details.open = false;
          this.summary.focus();
        });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.details.open = false;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
